import React from 'react';
import TwitterIcon from '../../assets/svg/logos/twitter.svg';
import LinkedinIcon from '../../assets/svg/logos/linkedin.svg';
import FacebookIcon from '../../assets/svg/logos/facebook-icon.svg';
import RssIcon from '../../assets/svg/logos/rss.svg';
import GithubIcon from '../../assets/svg/logos/github.svg';
import GlassdoorIcon from '../../assets/svg/logos/glassdoor-icon.svg';
import { StyledSocialUl } from './styles';

const SocialUl = () => (
  <StyledSocialUl>
    <li>
      <a
        href="https://twitter.com/sendgrid"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <TwitterIcon />
      </a>
    </li>
    <li>
      <a
        href="https://www.linkedin.com/company/sendgrid"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <LinkedinIcon />
      </a>
    </li>
    <li>
      <a
        href="https://www.facebook.com/SendGrid"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <FacebookIcon />
      </a>
    </li>
    <li>
      <a
        href="https://www.glassdoor.com/Overview/Working-at-SendGrid-EI_IE466121.11,19.htm"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <GlassdoorIcon />
      </a>
    </li>
    <li>
      <a
        href="https://github.com/sendgrid"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <GithubIcon />
      </a>
    </li>
    <li>
      <a
        href="https://sendgrid.com/blog/feed/"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <RssIcon />
      </a>
    </li>
  </StyledSocialUl>
);

export default SocialUl;
